export default class FormItemDecimalResolver
{
	
	static ROUNOFF_HALFUP = "HalfUp";
	static ROUNOFF_HALFDOWN = "HalfDown";
	static ROUNOFF_UP = "Up";
	static ROUNOFF_DOWN = "Down";
	static ROUNOFF_CEILING = "Ceiling";
	static ROUNOFF_FLOOR = "Floor";
	static ROUNOFF_HALFEVEN = "HalfEven";
	
	static resolverInstance;
	
	static getInstance()
	{
		if(FormItemDecimalResolver.resolverInstance == null)
			FormItemDecimalResolver.resolverInstance = new FormItemDecimalResolver();
		return resolverInstance;
	}
	
	static filtZero(value)
	{
		var index = 0;
		var isNegtive = false;
		if(value.charAt(index)=="-")
		{
			index ++;
			isNegtive = true;
		}
		while(value.charAt(index)=="0" && value.charAt(index+1)!=".")
		{
			index ++;
		}
		return isNegtive?"-"+value.substr(index):value.substr(index);
	}
	
	static getResult()
	{
		var value = arguments[0]
		var reg1 = /^-0+$/;
		var reg2 = /^0+$/;
		var numOfDecimals = parseInt(arguments[3]);
		if(isNaN(numOfDecimals))
			throw new Error("小数位数在FormItem中为不合法的非数字");
		if(value == "")
			value = "0";
		if(typeof(value) == "number")
		{
			value = value+"";
		}
		var temp = value.charAt(0) == "-"?value.substr(1):value;
		var maxprecision = 15 - temp.split(".")[0].length;
		if(maxprecision < numOfDecimals)
			return "false:超过支持精度";
		
		var notNull = arguments[1] ;	
		if(reg1.exec(value)!=null || reg2.exec(value)!=null)
		{
			if(notNull == true)
				return "false:不允许空值";
			var result = "0";
			var numOfDecimalsCopy = numOfDecimals;
			if(numOfDecimalsCopy > 0)
				result += ".";
			while(numOfDecimalsCopy!=0)
			{
				result += "0";
				numOfDecimalsCopy -- ;
			}
			return result;
		}
		
		
		var allowNegative = arguments[2];
		//var numOfDecimals:uint = args[2] as uint;
		var roundOff = arguments[4];
		var regu = /^(\-|\+)?\d+(\.\d+)?$/;
		if(regu.test(value))
		{
			if(value.indexOf(".") != -1)
			{
				if(value.charAt(0) == ".")
					value = "0" + value;
				else if(value.charAt(1) == "." && (value.charAt(0) == "-" || value.charAt(0) == "+"))
					value = value.charAt(0) + "0" + value.substr(1);
				
				if(Number(value) == 0 && notNull == true)
					return "false:不允许空值";
				
				var chars = value.split(".")[1];
				
				if(Number(value)<0 && !allowNegative)
				{
					value = Math.abs(Number(value))+"";
					if(value.indexOf(".") == -1)
						value += "." + chars;
				}
				
				while(chars.length<numOfDecimals)
				{
					value += "0";
					chars = value.split(".")[1];
				}
				
				if(chars.length == numOfDecimals)
				{
					//return String(parseFloat(value));
					return FormItemDecimalResolver.filtZero(value);
					
				}
				
				if(chars.length > numOfDecimals)
				{
					if(roundOff == FormItemDecimalResolver.ROUNOFF_UP)
					{
						return FormItemDecimalResolver.getUp(value,chars,numOfDecimals);
					}
					
					if(roundOff == FormItemDecimalResolver.ROUNOFF_DOWN)
					{
						return FormItemDecimalResolver.getDown(value,chars,numOfDecimals);
					}
					
					if(roundOff == FormItemDecimalResolver.ROUNOFF_HALFDOWN)
					{
						return FormItemDecimalResolver.getHalfDown(value,chars,numOfDecimals);
					}
					
					if(roundOff == FormItemDecimalResolver.ROUNOFF_HALFUP)
					{
						return FormItemDecimalResolver.getHalfUp(value,chars,numOfDecimals);
					}
					
					if(roundOff == FormItemDecimalResolver.ROUNOFF_HALFEVEN)
					{
						return FormItemDecimalResolver.getHalfEven(value,chars,numOfDecimals);
					}
					
					if(roundOff == FormItemDecimalResolver.ROUNOFF_CEILING)
					{
						return FormItemDecimalResolver.getCeiling(value,chars,numOfDecimals); 
					}
					
					if(roundOff == FormItemDecimalResolver.ROUNOFF_FLOOR)
					{
						return FormItemDecimalResolver.getFloor(value,chars,numOfDecimals);
					}
					else
					{
						return FormItemDecimalResolver.getUnNecessary(value,chars,numOfDecimals);
					}
					
				}
			}
			else
			{
				value = FormItemDecimalResolver.filtZero(value);
				if(Number(value) == 0 && notNull == true)
					return "false:不允许空值";
				if(Number(value)<0 && !allowNegative)
				{
					value = value.substr(1);
				}
				if(numOfDecimals>0)
				{
					var i = 0;
					value += ".";
					while(i<numOfDecimals)
					{
						value += "0";
						i++;
					}
				}
				return value;
			}
			
			
		}
		else
		{
			return "false:不是有效的小数格式";
		}
		
		throw new Error("decimal validate");
		
	}
	
	
	static getUp(value,chars,numOfDecimals)
	{
		var temp;
		value = FormItemDecimalResolver.filtZero(value);
		if(chars.length == 1 || numOfDecimals == 0)
		{
			var endChar = value.split(".")[0].substr(-1);
			temp = endChar;
			temp ++ ;
			endChar =temp; 
			value = value.split(".")[0];
			var result = value.substr(0,value.length-1) + endChar ;
			return result;
		}
		else
		{
			endChar = chars.charAt(numOfDecimals-1);
			temp = endChar;
			temp ++ ;

			endChar =temp;
			chars = chars.substr(0,numOfDecimals-1) + endChar;
			result = value.split(".")[0] + "." + chars;
			return result;
		}
	}
	
	
	static getDown(value,chars,numOfDecimals)
	{
		value = FormItemDecimalResolver.filtZero(value);
		if(chars.length == 1 || numOfDecimals == 0)
		{
			return value.split(".")[0];
		}
		else
		{
			chars = chars.substr(0,numOfDecimals);
			return value.split(".")[0] + "." + chars ;
		}
	}
	
	static getHalfDown(value,chars,numOfDecimals)
	{
		if(numOfDecimals == 0)
		{
			endChar = value.charAt(value.indexOf(".")+1);
		}
		else
		{
			var endChar = chars.charAt(numOfDecimals);
			
		}
		
		
		if(endChar == "5")
		{
			return FormItemDecimalResolver.getDown(value,chars,numOfDecimals);
		}
		else
		{
			return FormItemDecimalResolver.getHalfUp(value,chars,numOfDecimals);
		}
	}
	
	static getHalfUp(value,chars,numOfDecimals)
	{
		let temp = 1;
		let i = numOfDecimals;
		while(i>0)
		{
			temp = temp*10;
			i --;
		}
		if(typeof(value) == "string")
		{
			value = parseFloat(value);
		}
		let valueTemp = value*temp + 0.0000000001;
		let roundValueTemp = Math.round(valueTemp);
		let result = roundValueTemp/temp + "";
		if(numOfDecimals>0 && result.indexOf(".") != -1)
		{
			let endChars = result.substring(result.indexOf(".")+1,result.length);
			while(endChars.length<numOfDecimals)
			{
				endChars+="0";
				result+='0';
				numOfDecimals--;
			}
		}
		// 当保留2位小数 入 0.998 时  只显示1  TODO_YL 修正
		if(numOfDecimals>0 && result.indexOf(".") == -1){
			var zeor = ".";
			for(let i=0;i<numOfDecimals;i++){
				zeor = zeor+"0";
			}
			result = result+zeor;
		}
	
		return result;

		value = FormItemDecimalResolver.filtZero(value);
		
		if(numOfDecimals == 0)
		{
			var endChar = value.charAt(value.indexOf(".")+1);
		}
		else
		{
			endChar = chars.charAt(numOfDecimals);
			
		}
		
		
		if(endChar == "5")
		{
			return FormItemDecimalResolver.getUp(value,chars,numOfDecimals);
		}
		else
		{
			var num = Number(value);
			
			return num.toFixed(numOfDecimals);
		}
		
	}
	
	
	static getHalfEven(value,chars,numOfDecimals)
	{
		//保证numOfDecimals<chars.length
		if(numOfDecimals == 0)
		{
			var endChar = value.charAt(value.indexOf(".")-1);
		}
		else
		{
			endChar = chars.charAt(numOfDecimals-1);
			
		}
		var num = Number(endChar);
		if(num%2 == 0)
		{
			return FormItemDecimalResolver.getHalfDown(value,chars,numOfDecimals);
		}
		else
		{
			return FormItemDecimalResolver.getHalfUp(value,chars,numOfDecimals);
		}
	}
	
	static getCeiling(value,chars,numOfDecimals)
	{
		//value = filtZero(value);
		var num = Number(value);
		if(num < 0)
		{
			return FormItemDecimalResolver.getDown(value,chars,numOfDecimals);
		}
		else
		{
			return FormItemDecimalResolver.getUp(value,chars,numOfDecimals);
		}
	}
	
	
	static getFloor(value,chars,numOfDecimals)
	{
		//value = filtZero(value);
		var num = Number(value);
		if(num < 0)
		{
			return FormItemDecimalResolver.getUp(value,chars,numOfDecimals);
		}
		else
		{
			return FormItemDecimalResolver.getDown(value,chars,numOfDecimals);
		}
	}
	
	static getUnNecessary(value,chars,numOfDecimals)
	{
		if(chars.length > numOfDecimals)
		{
			chars = chars.substr(0,numOfDecimals);
		}
		
		return value.split(".")[0] + chars;
	}
	
}



// WEBPACK FOOTER //
// ./src/formItem/resolver/FormItemDecimalResolver.js